











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { EventBus } from '@/utils/EventBus';
import { validateAccount, canAdoptCount, getAdoptionPrice, adoptAlpaca } from '@/utils/web3';
import BigNumber from 'bignumber.js';
import { alpaUnit } from '@/utils/unit';
import AlpacaPreview from '@/components/AlpacaPreview.vue';
import { getAlpacaCount } from '@/backend/requests';

@Component({
  components: {
    AlpacaCard,
    AlpacaBtn,
    AlpacaPreview,
  },
})
export default class Adopt extends Vue {
  public count: number = 1;
  public totalPrice: BigNumber = new BigNumber(0);
  public remainingCount: number = -1;
  public presaleRemaining: number = 0;

  get totalAlpa() {
    return alpaUnit(this.totalPrice);
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  get canAdopt() {
    return this.remainingCount !== -1 &&
    this.remainingCount >= Number(this.count) &&
    this.presaleRemaining >= Number(this.count);
  }

  get notEnoughAlpaca() {
    return this.remainingCount !== -1 && (
    this.remainingCount < Number(this.count) ||
    this.presaleRemaining < Number(this.count) );
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  public mounted() {
    this.countChange();
    this.remainingAlpacas();
    this.getPresaleRemaining();
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public async getPresaleRemaining() {
    const res = await getAlpacaCount(process.env.VUE_APP_PRESALE_CONTRACT_ADDRESS!);
    if (res) {
      this.presaleRemaining = res.data;
    }
  }

  public async countChange() {
    if (this.count) {
      this.totalPrice = await getAdoptionPrice(this.count);
    }
  }

  public async remainingAlpacas() {
    if (!this.account) {
      return;
    }
    this.remainingCount = Number(await canAdoptCount(this.account));
  }

  public async handleAdopt() {
    if (this.notEnoughAlpaca) {
      return;
    }
    adoptAlpaca(this.totalPrice, this.count, this.$store.getters.getAccount);
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.countChange();
      this.remainingAlpacas();
      this.getPresaleRemaining();
    }
  }
}
